import { createStore } from 'vuex'
import getters from './getters'
import user from './modules/user'
import notice from './modules/notice'
import search from './modules/search'
import personalCenter from './modules/personal-center'
import websiteConfigure from './modules/website-configure'
import websiteDetails from './modules/website-details'
import i18n from '@/languages'

// 创建一个 Vuex 存储实例，用于管理应用程序的状态
const store = createStore({
    // 定义 Vuex 模块，将各个模块整合到 store 中
    modules: { user, notice, search, personalCenter, websiteConfigure, websiteDetails },

    // 定义 store 的状态，这里的状态是全局可访问的
    state: {
        // 定义一个名为 count 的状态，初始值为 1000
        count: 1000,
        L: i18n.global.t.bind(i18n.global),
    },
    // 定义修改 state 的方法，这些方法必须是同步的
    mutations: {
        // 定义一个名为 increment 的 mutation，用于将 count 状态的值加 1
        increment(state) {
            state.count++
        },
    },
    // 定义从 state 中派生出一些状态的方法，类似于计算属性
    getters: {
        // 定义一个名为 doubleCount 的 getter
        doubleCount: state => state.count,
        L: i18n.global.t.bind(i18n.global),


    },
    // 定义用于处理异步操作或者复杂逻辑的方法，最终通过 commit 调用 mutations 来修改 state
    actions: {
        // 定义一个名为 increment 的 action，通过 commit 调用 increment mutation 来修改 count 状态
        increment(context) {
            context.commit('increment')
        },
    }


})

export default store
// myModule.js